import { SUPPORTER_HOME } from "../../ForSupporters/v2/SupporterModeLayout";
import { ATHLETE_LANDING } from "../../../constants";

export { ATHLETE_LANDING };

// Where a signed-in account lands: /login and /register send a signed-in
// visitor here, and the no-access and 404 pages offer it as "my home".
// The order matters for accounts holding more than one role.
//   - Coaches land in Coach Mode, unless they are also admins or Cache AI
//     staff, who keep the business dashboard.
//   - Pure brand/agency accounts land in Brand Mode.
//   - Other business roles land on the Player Index.
//   - Athletes land on My Profile (ATHLETE_LANDING); interns, reps and
//     supporters land on their own home.
// Returns null when no role has a home (the caller shows its own page).
export const landingPathFor = (permissions) => {
  const has = (p) => (permissions || []).includes(p);
  const staff = has("IS_ADMIN") || has("IS_CACHE_AI");
  if (has("IS_COACH") && !staff) return "/coach/home";
  if (has("IS_BRAND_AGENCY") && !staff) return "/brand/discover";
  if (has("IS_BRAND_AGENCY") || staff || has("IS_AD_PD") || has("IS_RECRUITER_SCOUT")) return "/business/dashboard";
  if (has("IS_ATHLETE")) return ATHLETE_LANDING;
  if (has("IS_INTERN")) return "/users";
  if (has("IS_REP")) return "/rep/home";
  if (has("IS_SUPPORTER")) return SUPPORTER_HOME;
  return null;
};

// Where the old athlete profile link (/business/athlette/profile/:athleteId?)
// sends each account: the athlete page inside the shell the account works
// in, so every caller can keep that one link.
//   - Coaches who are not admins or Cache AI staff: Coach Mode.
//   - Pure brand/agency accounts: Brand Mode.
//   - Reps who are not admins: Rep Mode.
//   - Everyone else: the Player Index shell.
// The athlete (an ObjectId or an email) is kept, URL-encoded, and left off
// when missing: the page then falls back to the last athlete opened, and a
// rep lands on the Athletes list (/rep/athletes).
export const athleteProfilePathFor = (permissions, athleteId) => {
  const has = (p) => (permissions || []).includes(p);
  const staff = has("IS_ADMIN") || has("IS_CACHE_AI");
  let base = "/business/athletes";
  if (has("IS_COACH") && !staff) base = "/coach/athletes";
  else if (has("IS_BRAND_AGENCY") && !staff) base = "/brand/athletes";
  else if (has("IS_REP") && !has("IS_ADMIN")) base = "/rep/athletes";
  return athleteId ? `${base}/${encodeURIComponent(athleteId)}` : base;
};

// Where the retired /payments-history link sends each account: its billing
// page, or its home for roles without one. Null when no role matches.
//   - Admins: the payments admin page.
//   - Athletes: Athlete Mode billing; coaches: Coach Mode billing.
//   - Pure brand/agency accounts (not Cache AI staff): Brand Mode billing.
//   - Recruiters, AD/PD and staff brands: the Player Index billing.
//   - Reps and supporters: their home.
export const billingPathFor = (permissions) => {
  const has = (p) => (permissions || []).includes(p);
  if (has("IS_ADMIN")) return "/admin/payments";
  if (has("IS_ATHLETE")) return "/athlete/billing";
  if (has("IS_COACH")) return "/coach/billing";
  if (has("IS_BRAND_AGENCY") && !has("IS_CACHE_AI")) return "/brand/billing";
  if (has("IS_BRAND_AGENCY") || has("IS_RECRUITER_SCOUT") || has("IS_AD_PD")) return "/business/billing";
  if (has("IS_REP")) return "/rep/home";
  if (has("IS_SUPPORTER")) return SUPPORTER_HOME;
  return null;
};
